<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <p style="text-align:center;font-size:25px;font-weight:bold">
        التحصيلات التي لم يتم التأكد عليها
      </p>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="البحث"
        single-line
        hide-details
      ></v-text-field>
      <v-data-table
        :headers="headers"
        :items="the_tahsilats_done"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status === '0'
                ? { 'background-color': 'yellow' }
                : { 'background-color': '#fff' }
            ]"
          >
            <td>{{ props.item.client_name }}</td>
            <td class="text-xs-right">{{ props.item.money }}</td>
            <td class="text-xs-right">
              {{
                props.item.client && props.item.client.mandob_sales
                  ? props.item.client.mandob_sales.name
                  : ""
              }}
            </td>
            <td class="text-xs-right">
              {{
                props.item.client && props.item.client.mandob_taworid
                  ? props.item.client.mandob_taworid.name
                  : ""
              }}
            </td>
            <td class="text-xs-right">
              {{
                props.item.user && props.item.user.employer
                  ? props.item.user.employer.name
                  : ""
              }}
            </td>
            <td class="text-xs-right">
              {{ props.item.created_at.substr(0, 10) }}
            </td>

            <td style="padding:0px">
              <v-btn
                v-if="props.item.status === '0'"
                small
                color="orange"
                style="margin:0px;padding:0px"
                @click.prevent="confirm_tahsilat(props.item)"
              >
                <!-- @click="confirm_fatwora" -->
                تم التاكيد
              </v-btn>
              <p v-else>
                تم التاكيد بتاريخ {{ props.item.updated_at.substr(0, 10) }}
              </p>
            </td>

            <td>
              <v-btn sm color="red" @click="deleteItem(props.item)"
                ><v-icon>delete</v-icon></v-btn
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>

    <v-container>
      <p style="text-align:center;font-size:25px;font-weight:bold">
        التحصيلات التي تم التأكد عليها
      </p>
      <v-text-field
        v-model="search2"
        append-icon="search"
        label="البحث"
        single-line
        hide-details
      ></v-text-field>
      <v-data-table
        :headers="headers"
        :items="the_tahsilats_not_done"
        class="elevation-1"
        :search="search2"
        :loading="loading"
        :pagination.sync="pagination2"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status === '0'
                ? { 'background-color': 'yellow' }
                : { 'background-color': '#fff' }
            ]"
          >
            <td>{{ props.item.client_name }}</td>
            <td class="text-xs-right">{{ props.item.money }}</td>
            <td class="text-xs-right">
              {{
                props.item.client && props.item.client.mandob_sales
                  ? props.item.client.mandob_sales.name
                  : ""
              }}
            </td>
            <td class="text-xs-right">
              {{
                props.item.client && props.item.client.mandob_taworid
                  ? props.item.client.mandob_taworid.name
                  : ""
              }}
            </td>
            <td class="text-xs-right">
              {{
                props.item.user && props.item.user.employer
                  ? props.item.user.employer.name
                  : ""
              }}
            </td>
            <td class="text-xs-right">
              {{ props.item.created_at.substr(0, 10) }}
            </td>

            <td style="padding:0px">
              <v-btn
                v-if="props.item.status === '0'"
                small
                color="orange"
                style="margin:0px;padding:0px"
                @click.prevent="confirm_tahsilat(props.item)"
              >
                <!-- @click="confirm_fatwora" -->
                تم التاكيد
              </v-btn>
              <p v-else>
                تم التاكيد بتاريخ {{ props.item.updated_at.substr(0, 10) }}
              </p>
            </td>

            <td>
              <v-btn sm color="red" @click="deleteItem(props.item)"
                ><v-icon>delete</v-icon></v-btn
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search2 }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination2.page"
          :length="pages2"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import {
  log_me,
  tahsilat,
  delete_tahsil,
  confirm_tahsilat
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    dialog: false,

    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    item_detail: {},
    detail_dialog: false,

    select_sadad_type: { id: "", job_name: "", name: "أختر نوع السداد" },
    select_client: { id: "", job_name: "", name: "أختر المورد" },
    select_employer: { id: "", job_name: "", name: "أختر المسئول" },
    select_store: { id: "", job_name: "", name: "أختر المخزن" },
    select_item: { id: "", job_name: "", name: "أختر الصنف" },
    select_sadadstatuses: { name: "" },

    search: "",
    search2: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    pagination2: {
      rowsPerPage: 30,
      descending: true
    },
    headers: [
      {
        text: "العميل ",
        align: "right",
        value: "client_name"
      },
      { text: "المبلغ ", value: "money", align: "right" },
      {
        text: " مندوب المبيعات",
        value: "client.mandob_sales.name",
        align: "right"
      },
      {
        text: " مندوب التوريد",
        value: "client.mandob_taworid.name",
        align: "right"
      },
      { text: "بواسطة", value: "user.employer.name", align: "right" },
      { text: "التاريخ", value: "created_at", align: "right" },
      { text: " تم التأكيد", value: "store", sortable: false, align: "right" },
      { text: " حذف", value: "store", sortable: false, align: "right" }
    ],
    headers3: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      { text: " العدد", value: "client_name", sortable: false, align: "right" },
      {
        text: " العدد النهائي",
        value: "item_num_after",
        sortable: false,
        align: "right"
      },
      {
        text: "   البونص",
        value: "item_bonus",
        sortable: false,
        align: "right"
      }
    ],

    the_tahsilats_done: [],
    the_tahsilats_not_done: [],
    m_sadad_types: [],
    m_employers: [],
    clients: [],
    m_items: [],
    stores: [],
    client_search_name: "",
    sadadstatuses: [],
    added_items: [],
    madionia_sabqa_of_madionia: ""
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    pages2() {
      if (
        this.pagination2.rowsPerPage == null ||
        this.pagination2.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination2.totalItems / this.pagination2.rowsPerPage
      );
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    // this.initialize()
    //  sadadtypes().then((response)=>{
    //          this.m_sadad_types=response.data
    //               });

    //       employers().then((response)=>{
    //         this.m_employers=response.data
    //       })

    //       items().then((response)=>{
    //         this.m_items=response.data
    //       })

    //       clients().then((response)=>{
    //         this.clients=response.data
    //       })

    this.tahsilat();

    // stores().then((response)=>{
    //   this.stores=response.data

    // })

    // sadadstatuses().then((response)=>{
    //   this.sadadstatuses=response.data

    // })
  },

  methods: {
    initialize() {},
    tahsilat() {
      tahsilat().then(response => {
        this.the_tahsilats_done = response.data.tahsilat_done;
        this.the_tahsilats_not_done = response.data.tahsilat_not_done;
        this.pagination.totalItems = response.data.tahsilat_done.length;
        this.pagination2.totalItems = response.data.tahsilat_not_done.length;
        this.loading = false;
      });
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.the_tahsilats_done.indexOf(item);

          this.loading = true;
          delete_tahsil(item.id).then(response => {
            this.loading = false;
            this.the_tahsilats_done.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
    },

    confirm_tahsilat(item) {
      let myUser = JSON.parse(localStorage.getItem("user"));
      this.loading = true;
      confirm_tahsilat(item.id).then(response => {
        this.loading = false;
        this.tahsilat();
        let myUser = JSON.parse(localStorage.getItem("user"));
        var frmData3 = new FormData();
        frmData3.append("title", "التاكيد علي تحصيل مندوب");
        frmData3.append(
          "body",
          "تم التاكيد علي  تحصيل مندوب لعميل " +
            item.client_name +
            " بواسطة " +
            myUser.name
        );
        frmData3.append("type", "confirm_tahsilat");
        frmData3.append("user_id", myUser.id);
        log_me(frmData3).then(response => {
          if (response.data == true) {
            let mytitle = "التاكيد علي  تحصيل مندوب";
            let mybody =
              "تم التاكيد علي  تحصيل مندوب لعميل  " +
              item.client_name +
              " بواسطة " +
              myUser.name;
            this.$toastr.warning(mybody, mytitle, {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "25000"
            });
          }
        });
      });
    },

    detailItem(order) {
      this.item_detail = order;
    }
  }
};
</script>

<style scope>
.v-datatable__actions {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.flex,
.v-input.v-text-field,
.v-input__control {
  padding: 0px !important;
  margin: 0px !important;
}
.v-card__title,
.v-card__text {
  padding: 0px;
  margin: 0px;
}
</style>
